import React, { useState } from "react";
import style from "./contactForm.module.css";
import dummyLogo from "./assets/logo.png";
import pin from './assets/pin.svg';
import phone from './assets/phone.svg';
import whatsapp from './assets/whatsapp.svg';
import mail from './assets/mail.svg';
import { useNavigate } from "react-router-dom";

const ContactForm = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    message: "",
  });

  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [acceptedTerms, setAcceptedTerms] = useState(false);
  const [termsError, setTermsError] = useState(false);
  const navigate = useNavigate()


  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!acceptedTerms) {
      setTermsError(true);
      return;
    }
    setLoading(true);
    setSuccess(false);

    try {
      const res = await fetch(
        "https://script.google.com/macros/s/AKfycbzoY2yoyMJYIuB1r6hvRJc0u-Xl6_mZwaqkhNzFoSp61tL2PEL5os_gCImcYz_Fok42/exec",
        {
          method: "POST",
          body: JSON.stringify(formData),
        }
      );

      if (res.ok) {
        setSuccess(true);
        setFormData({
          firstName: "",
          lastName: "",
          email: "",
          phone: "",
          message: "",
        });
      }
    } catch (error) {
      console.error("Error!", error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {loading && (
        <div className={style["contactForm-loaderOverlay"]}>
          <div className={style["contactForm-spinner"]}></div>
        </div>
      )}

      <div className={style["contactForm-section"]}>
        <div className={style["contactForm-container"]}>
          {/* Left Section */}
          <div className={style["contactForm-left"]}>
            <img
              src={dummyLogo}
              alt="Logo"
              className={style["contactForm-logo"]}
            />

            <div>
              <div className={style["contactForm-location"]}>
                <img src={pin} alt="pin" />
                <h5>ISKCON SRI RADHA SHYAM SUNDAR MANDIR</h5>
              </div>
              <h6>
                <a
                  href="https://maps.app.goo.gl/viF4YDydn2SDzRi28"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Main Temple - Amaravathi Karakatta Road, Undavalli, Vijayawada,
                  522 501
                </a>
              </h6>

              <div className={style["contactForm-location"]}>
                <img src={pin} alt="pin" />
                <h5>ISKCON SRI JAGANNATH MANDIR</h5>
              </div>
              <h6>
                <a
                  href="https://maps.app.goo.gl/c3hFWvqTRbtSXtW8A"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  City Temple - Skew Bridge, Krishna Lanka, Vijayawada - 520013
                </a>
              </h6>
            </div>

            <div className={style["contactForm-contactDetails"]}>
              <div className={style["contactForm-iconRow"]}>
                <img src={phone} alt="phone" />
                <span>Call: 8006880038</span>
              </div>
              <div className={style["contactForm-iconRow"]}>
                <img src={whatsapp} alt="whatsapp" />
                <span>Whatsapp: 9955685568</span>
              </div>
              <div className={style["contactForm-iconRow"]}>
                <img src={mail} alt="mail" />
                <span>Email: seva@iskconvijayawada.org</span>
              </div>
            </div>
          </div>

          {/* Right Side - Form */}
          <form className={style["contactForm-box"]} onSubmit={handleSubmit}>
            <h2 className={style["contactForm-title"]}>
              <span style={{ color: "orange" }}>CONTACT</span> FORM
            </h2>

            <div className={style["contactForm-row"]}>
              <input
                className={style["contactForm-input"]}
                type="text"
                name="firstName"
                placeholder="First Name *"
                value={formData.firstName}
                onChange={handleChange}
                required
              />
              <input
                className={style["contactForm-input"]}
                type="text"
                name="lastName"
                placeholder="Last Name *"
                value={formData.lastName}
                onChange={handleChange}
                required
              />
            </div>

            <div className={style["contactForm-row"]}>
              <input
                className={style["contactForm-input"]}
                type="email"
                name="email"
                placeholder="Email *"
                value={formData.email}
                onChange={handleChange}
                required
              />
              <input
                className={style["contactForm-input"]}
                type="text"
                name="phone"
                placeholder="Phone *"
                value={formData.phone}
                onChange={handleChange}
                required
              />
            </div>

            <textarea
              className={style["contactForm-textarea"]}
              name="message"
              placeholder="Your Message *"
              value={formData.message}
              onChange={handleChange}
              required
            />

            <div className={style["contactForm-terms"]}>
              <label style={{ display: "flex", alignItems: "center", gap: "8px", fontSize: "0.9rem", color: "white" }}>
                <input
                  style={{ cursor: "pointer" }}
                  type="checkbox"
                  checked={acceptedTerms}
                  onChange={() => {
                    setAcceptedTerms(!acceptedTerms);
                    setTermsError(false);
                  }}
                />

                <span >
                  I accept all the <span onClick={() => navigate('/policies-usage/term--conditions')} style={{color: "yellow", cursor: "pointer"}}>terms and conditions</span> and <span onClick={() => navigate('/policies-usage/term--conditions')}  style={{color: "yellow" , cursor: "pointer"}}>privacy policy</span>.
                </span>
              </label>
              {termsError && <p style={{ color: "yellow", fontSize: "0.8rem" }}>You must accept the terms and conditions to submit.</p>}
            </div>

            <button className={style["contactForm-button"]} type="submit">
              SUBMIT
            </button>

            {success && (
              <p className={style["contactForm-success"]}>
                Form submitted successfully!
              </p>
            )}
          </form>
        </div>
      </div>
    </>
  );
};

export default ContactForm;
